



















































import {
  Component,
  Prop,
  Vue,
} from "@/shared/vuepack";
import moment from "moment";
import {
  CombinedClaimReceiptStatus,
  CombinedClaimReceiptStatusMap,
  HsabExpenseCategory,
  HsabExpenseReimbursementResponse,
  HsabExpenseResponse,
} from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import Button from "@/shared/components/ui/Button.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import {
  expenseCategoryIcon,
  wexClaimReceiptStatusIcon
} from "@/shared/awesomeIconMapper";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {
    HsabExpenseForm,
    Pill,
    Button,
    CurrencyAmount,
  }
})
export default class HsabExpenseRow extends Vue {
  expenseCategoryIcon = expenseCategoryIcon;
  wexClaimReceiptStatusIcon = wexClaimReceiptStatusIcon;
  custodianSettingsStore = useCustodianSettingsStore();
  featureFlagStore = useFeatureFlagStore();
  hsabAccountsStore = useHsabAccountsStore();
  CombinedClaimReceiptStatusMap = CombinedClaimReceiptStatusMap;

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  @Prop()
  isSelected: boolean;

  isOpen = false;

  get expenseCategory (): HsabExpenseCategory {
    return this.expense.expenseCategory;
  }

  get title (): string {
    return this.expense.providerName;
  }

  get numberOfAttachments (): number {
    if (this.expense.expenseEvidence) {
      return this.expense.expenseEvidence.length;
    }

    return 0;
  }

  get isSubmittedExpense (): boolean {
    return this.expense.isSubmitted;
  }

  get isReadOnly () {
    return this.isSubmittedExpense;
  }

  toggleEdit (e: Event): void {
    e.preventDefault();
    this.isOpen = !this.isOpen;
  }

  onEditClose (): void {
    this.isOpen = false;
  }

  get formattedDate (): string {
    return moment(this.expense.dateOfService).format("MMM D, YYYY");
  }

  pillType (status: CombinedClaimReceiptStatus) {
    switch (status) {
      case CombinedClaimReceiptStatus.Paid:
        return "green-bg";
      case CombinedClaimReceiptStatus.ReceiptNeeded:
      case CombinedClaimReceiptStatus.NewReceiptNeeded:
      case CombinedClaimReceiptStatus.ReceiptOverdue:
        return "red-bg";
    }
    return "grey-bg";
  }

  showStatusPill (status: CombinedClaimReceiptStatus) {
    return this.hsabAccountsStore.userHasAnyNotionalAccounts
        && status !== CombinedClaimReceiptStatus.None;
  }
  get Reimbursement (): HsabExpenseReimbursementResponse {
    return this.expense.reimbursement;
  }
}

